import {
  UPDATE_LOAD_PAYMENT,
  RESET_LOAD_PAYMENT
} from "./actionTypes"

export const update_load_payment = load_payment => {
  return {
    type: UPDATE_LOAD_PAYMENT,
    payload: load_payment,
  }
}

export const reset_load_payment = () => {
  return {
    type: RESET_LOAD_PAYMENT,
  }
}
